<template>
  <div>
    <base-material-card color="secondary" icon="mdi-cube-outline" :title="$t('registry_products')">
      <v-layout justify-center style="flex-wrap: wrap">
        <v-radio-group row justify-center v-model="filter" @change="loadTable()">
          <v-radio :label="$t('active_m_p')" value="active"></v-radio>
          <v-radio :label="$t('all_m_p')" value="all"></v-radio>
        </v-radio-group>
        <v-btn small @click="createProduct" color="primary">{{
          $t("create_product")
        }}</v-btn>
      </v-layout>
      <DataTables @editProduct="editProduct" @viewProduct="viewProduct" @copyProduct="copyProduct" :headers="headers"
        :tableData="tableData"></DataTables>
    </base-material-card>
    <edit-product ref="gestProductDialog" @isUpdated="loadTable"></edit-product>
  </div>
</template>

<script>
import gestProduct from "@/app/prodotti/gestProduct.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-products",
  components: {
    DataTables,
    "edit-product": gestProduct,
  },
  data() {
    return {
      filter: "active",
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("code"), value: "productCode" },
        { text: this.$t("title"), value: "title" },
        { text: this.$t("description"), value: "descr", type: "html" },
        {
          text: this.$t("active_m_s"),
          value: "iconActive",
          type: "icons",
        }, {
          text: this.$t("quantity"),
          value: "qta",
        },
        {
          text: this.$t("auto_evasion"),
          value: "iconAutoEvasione",
          type: "icons",
        },
        {
          text: this.$t("show_in_asd"),
          value: "iconShowInAsd",
          type: "icons",
        },
        {
          text: this.$t("only_for_affiliated"),
          value: "iconOnlyTesserati",
          type: "icons",
        }, {
          text: this.$t("can_buy_with_credits"),
          value: "iconBuyWithCredits",
          type: "icons",
        }, {
          text: this.$t("force_order_approve"),
          value: "iconForceApprove",
          type: "icons",
        },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },
  methods: {
    viewProduct(item) {
      this.$refs.gestProductDialog.open("VIEW", item.idProduct);
    },
    createProduct() {
      this.$refs.gestProductDialog.open("ADD", null);
    },
    editProduct(item) {
      this.$refs.gestProductDialog.open("EDIT", item.idProduct);
    },
    copyProduct(item) {
      this.$refs.gestProductDialog.open("ADD", item.idProduct);
    },
    loadTable() {
      let _ = this;
      let url = "/auth/prodotti/listProducts";
      if (_._data.filter === "all") url += "/all";
      _._data.tableData = [];
      _._data.isFetching = true;
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        let data = response.data
          .filter((el) => {
            return el.extUrl === false;
          })
          .map(function (item) {
            item.options = [
              {
                icon: "mdi-magnify",
                color: "green",
                function: "viewProduct",
                text: _.$t("view_product"),
              },
              {
                icon: "mdi-pencil",
                color: "primary",
                function: "editProduct",
                text: _.$t("edit_product"),
              },
              {
                icon: "mdi-content-copy",
                color: "primary",
                function: "copyProduct",
                text: _.$t("copy_product"),
              },
            ];

            if (item.attivo === 1)
              item.iconActive = [{ icon: "mdi-check", color: "green" }];
            if (item.autoEvasione === 1)
              item.iconAutoEvasione = [{ icon: "mdi-check", color: "green" }];
            if (item.showInAsd === 1)
              item.iconShowInAsd = [{ icon: "mdi-check", color: "green" }];
            if (item.onlyTesserati === 1)
              item.iconOnlyTesserati = [{ icon: "mdi-check", color: "green" }];
            if (item.buyWithCredits === 1)
              item.iconBuyWithCredits = [{ icon: "mdi-check", color: "green" }];
            if (item.forceOrderApprove === 1)
              item.iconForceApprove = [{ icon: "mdi-check", color: "green" }];
            if (item.tempQtaOrdered && item.tempQtaOrdered > 0) {
              item.qta = (item.qta - item.tempQtaOrdered) + ' (' + item.tempQtaOrdered + ')'
            }
            return item;
          });
        _._data.tableData = data;
        _._data.isFetching = false;
      });
    },
  },
  created() {
    this.loadTable();
  },
};
</script>